import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { MatSort, Sort } from "@angular/material/sort";
import { Router } from '@angular/router';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';
import { EventService } from '../event.service';
import { TranslateService } from '@ngx-translate/core';
import { EChartOption } from 'echarts';
import { environment } from 'src/environments/environment';
import { DeadlineModalsComponent } from '../dashboardModals/deadline-modals/deadline-modals.component';
import { PreShipmentModalsComponent } from '../dashboardModals/pre-shipment-modals/pre-shipment-modals.component';
import { PostShipmentModalsComponent } from '../dashboardModals/post-shipment-modals/post-shipment-modals.component';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as echarts from 'echarts';

export enum Interval {
  hrs = 'hour(s)',
  days = 'day(s)',
  weeks = 'week(s)',
  months = 'month(s)',
  years = 'year(s)'
}

const DashboardLayout = 'DashboardLayout';

@Component({
  selector: "app-overview",
  templateUrl: "./overview.component.html",
  styleUrls: ["./overview.component.scss"],
  animations: [
    trigger("fadeIn", [
      transition(":enter", [
        style({ opacity: "0" }),
        animate("1.5s ease-out", style({ opacity: "1" })),
      ]),
    ]),
  ],
})
export class OverviewComponent implements OnInit {
  @ViewChild("reorderRows", { static: true }) reorderRows: TemplateRef<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  showLoader = false; // flag for loader
  showFeedback = false;

  views = [];
  fromDate:any;
  checkValues = [];
  waybill_displayedColumns = ["shipment_id", "date_time", "action"];
  dueColumns = ["value", "day"];

  loading_off_loading_time_columns = [
    "locations",
    "loading_time",
    "unloading_time",
  ];
  show_warning = false;
  dataSource = new MatTableDataSource<any>([{
    _id: "",
    vehicleNo: "",
    state: "",
    available: "",
    expectedDate: "",
    remarks: "",
    remarksDate: "",
  }]);
  states:any = [
    {
        "_id": "5de611b6da1ed02b78e26fbe",
        "name": "Andhra Pradesh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fbf",
        "name": "Arunachal Pradesh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fbd",
        "name": "Andaman and Nicobar",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc0",
        "name": "Assam",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc8",
        "name": "Gujarat",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc1",
        "name": "Bihar",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc4",
        "name": "Dadra and Nagar Hav.",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc3",
        "name": "Chattisgarh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc5",
        "name": "Daman and Diu",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc6",
        "name": "Delhi",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fca",
        "name": "Himachal Pradesh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc2",
        "name": "Chandigarh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd3",
        "name": "Meghalaya",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc9",
        "name": "Haryana",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fcb",
        "name": "Jammu and Kashmir",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fcf",
        "name": "Lakshadweep",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fc7",
        "name": "Goa",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd4",
        "name": "Mizoram",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd0",
        "name": "Madhya Pradesh",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fcc",
        "name": "Jharkhand",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd5",
        "name": "Nagaland",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd9",
        "name": "Rajasthan",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fda",
        "name": "Sikkim",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd1",
        "name": "Maharashtra",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd6",
        "name": "Odisha",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fdb",
        "name": "Tamil Nadu",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd8",
        "name": "Punjab",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fce",
        "name": "Kerala",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fcd",
        "name": "Karnataka",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd2",
        "name": "Manipur",
        "checked": false
    },
    {
        "_id": "5de611b6da1ed02b78e26fd7",
        "name": "Puducherry",
        "checked": false
    },
    {
        "_id": "5df09a3c511a92a564d6c095",
        "name": "Tripura",
        "checked": false
    },
    {
        "_id": "5df09c35538de7a6837a21df",
        "name": "Uttarakhand",
        "checked": false
    },
    {
        "_id": "5df09d2a72cf15a7321688aa",
        "name": "West Bengal",
        "checked": false
    },
    {
        "_id": "5df09d985f4211a7562ee6de",
        "name": "Telangana",
        "checked": false
    },
    {
        "_id": "5df0a4eec8b35ba92de7eef1",
        "name": "Uttar Pradesh",
        "checked": false
    },
    {
        "_id": "5f4cb3aff0259dc6eaffb6f5",
        "name": "Ladakh",
        "checked": false
    },
    {
        "_id": "63107b6fe5a9da4346d6b780",
        "name": "Jharkhand - Patratu",
        "checked": false
    },
    {
        "_id": "63c34cff48070c401e6a487d",
        "name": "Jammu & Kashmir",
        "checked": false
    }
  ];
  selectedStateNamesString = "";
  selectedStatesArray = [];
  isStatesSelected = false;
  filteredOptions = [...this.states];
  searchTerm = '';
  dropdownOpen = false;
  vehicleChartOptions = {};
  selectedTab = 'Overview Dashboard';
  remarks = ["Available", "Not Available", "Moving towards plant"];
  selectedRemark = "";
  isRemarkSelected = false;
  mvTowardsPlantData = [];
  searchVehicle = '';
  previousTripsChart = [];
  availableVehiclesTrip = 0;
  totalTripChart = 0;
  previousVehiclesChartData = [];
  vehicleContactDetails={};

  displayedColumns=["SINo","vehicleNo","state","available","expectedDate","remarks","actions"]


  // stats settings
  stats_settings = {
    deadline_expiry: { count: "", type: "" },
    shipment_acceptance: { count: "", type: "" },
    shipment_pending: { count: "", type: "" },
    shipment_fulfilled: { count: "", type: "" },
    outstanding_epods: { count: "", type: "" },
    ongoing_shipment: { count: "", type: "" },
    operations_status: { count: "", type: "" },
    top_shippers: { count: "", type: "" },
    average_loading_topX: 0,
  };

  // deadline status data
  deadline_status: any = {
    acceptance: { value: "", loader: false },
    assignment: { value: "", loader: false },
  };

  // preshipment status data
  preShipment_pending_data: any = {
    acceptance: { value: "", loader: false },
    assignment: { value: "", loader: false },
  };

  // sim-tracking consent data
  sim_tracking_consent_data = {
    consent_available: 0,
    consent_unavailable: 0,
    consent: false,
    total_sum: 0,
    error_message: "",
    loader: false,
  };

  // driver acceptance status data
  driver_acceptance_status_data = {
    driver_accepted: 0,
    driver_yet_to_accept: 0,
    acceptance: false,
    total: 0,
    error_message: "",
    loader: false,
  };

  // tracking status data
  tracking_status_data = {
    trackable: 0,
    trackable_sim: 0,
    trackable_gps: 0,
    trackable_app: 0,
    non_trackable: 0,
    error_message: "",
    loader: false,
  };

  // live late shipment data
  live_late_shipments_data = {
    _id: null,
    delayed_shipments: 0,
    ontime_shipments: 0,
    error_message: "",
    loader: false,
  };

  // e-way bill expiring status data
  waybill_expiry_data = {
    loader: false,
    error_message: "",
    data: [],
  };

  // outstanding epods data
  outstanding_epods_data = {
    loader: false,
    error_message: "",
    value: "",
  };

  // operation status data
  operation_status_data = {
    at_pickup: 0,
    towards_pickup: 0,
    in_transit: 0,
    at_delivery: 0,
    delivered: 0,
    about_to_reach: 0,
    error_message: "",
    loader: false,
  };

  // fulfilled shipments variation graph
  dispatched_shipments_graph = {
    date: [],
    allocated: [],
    assigned: [],
    error_message: "",
    loader: false,
  };

  // fulfilled shipments variation graph
  fulfilled_shipments_graph = {
    date: [],
    requested: [],
    fulfilled: [],
    error_message: "",
    loader: false,
  };

  // fleet utilization data
  fleet_utilization_data = {
    total_vehicles: 0,
    free_vehicles: 0,
    on_shipment: 0,
    error_message: "",
    loader: false,
  };

  // revenue ytd data
  revenue_data = {
    value: 0,
    error_message: "",
    loader: false,
  };

  // loading and off loading time data
  loading_off_loading_time_data = {
    loader: false,
    error_message: "",
    data: [],
  };

  //delivery Point data
  delivery_point_data = {
    data: {
      sin: [],
      total_deliveries: [],
      finished_deliveries: [],
    },
    error_message: "",
    loader: false,
  };

  top_shippers = {
    shippers: [],
    total_vehicles: 0,
    loader: false,
    error_message: "",
  };

  progress_bar = {
    app: 0,
    sim: 0,
    gps: 0,
  };

  sim_tracking_progress_bar = {
    consent_available: 0,
    consent_unavailable: 0,
  };

  driver_acceptance_progress_bar = {
    driver_accepted: 0,
    driver_yet_to_accept: 0,
  };

  non_trackable_no;
  trackable_no;

  sim_tracking_consent_available;
  sim_tracking_consent_unavailable;

  driver_acceptance_status_accepted;
  driver_acceptance_status_yet_to_accept;

  // pre shipment graphs
  simTrackingConsentStatus: EChartOption = {};
  driverAcceptanceStatus: EChartOption = {};

  // In transit graphs
  trackingStatusOption: EChartOption = {};
  liveLateShipmentsOption: EChartOption = {};
  operationStatusOption: EChartOption = {};
  dispatchedShipmentsOption: EChartOption = {};
  requestedVsDispatchedOption: EChartOption = {};
  deliveryPointsOption: EChartOption = {};

  show_sim_tracker = false;
  currencySymbol;
  carrierId: Subscription;
  refreshIntervalId;

  dashboardLayoutDialog;
  colorPalette = ["#bc2f2f", "#183b6d"];
  sidebardata = [];
  postTransitShipmentCount: any = [];
  carrierName: string;
  carrierID:string;

  constructor(
    private http: HttpService,
    private storage: StorageService,
    private dialog: MatDialog,
    private router: Router,
    private snackbar: SnackbarService,
    private timeService: TimeService,
    private events: EventService,
    private translation: TranslateService
  ) {
    this.refreshIntervalId = setInterval(() => {
      this.refresh();
    }, 5 * 60 * 1000); // 5 mins auto refresh
    if (this.storage.getFromLocalStorage(DashboardLayout)) {
      this.views = JSON.parse(
        this.storage.getFromLocalStorage(DashboardLayout)
      );
    } else {
      this.views = [
        {
          name: "Deadline Status",
          id: "liveStatus",
          show: true,
        },
        {
          name: "Pre-shipment Status",
          id: "overview",
          show: true,
        },
        {
          name: "Acceptance Status",
          id: "acceptance",
          show: true,
        },
        {
          name: "In-Transit Shipment Status",
          id: "statusCharts",
          show: true,
        },
        {
          name: "Post-shipment Status",
          id: "variationGraphs",
          show: true,
        },
        {
          name: "Overall Metrics",
          id: "opsStatus",
          show: true,
        },
        {
          name: "Shipments Pending To Complete",
          id: "pendingShipments",
          show: true,
        },
      ];
    }
    this.checkView();
    this.checkValues = this.views.map((e) => (e.show ? e.id : undefined));
    this.show_sim_tracker = environment.country == "IN";
    const currency = JSON.parse(localStorage.getItem("carriers"));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierID = currency[0]._id;
    this.carrierName = currency[0].parent_name;
  }

  ngOnInit() {
    this.getDashboardData(); 
   
    this.sidebardata = [
      {
        title:'Overview Dashboard',
        icon:'assets/overview_black_bg-icon.svg',
        activeIcon: "assets/overview-white-bg-icon.svg"
      },
      {
        title:'Planning Tool',
        icon:'assets/available-vehicles-black-bg-icon.svg',
        activeIcon: "assets/available-vehicles-white-bg-icon.svg"
      },
    ]// get dashboard data
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getDashboardData();
        const rupee = JSON.parse(localStorage.getItem("carriers"));
        this.currencySymbol = rupee[0].country.currency.symbol;
      },
      (err: any) => {
        console.log("Err ::", err);
      }
    );
  }

  handleTabs(tab) {
    this.selectedTab = tab
    if(tab === 'Planning Tool'){
      this.getMVTowardsPlant({});
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    this.showFeedback = true;
    moveItemInArray(this.views, event.previousIndex, event.currentIndex);
  }

  ngOnDestroy() {
    clearInterval(this.refreshIntervalId); // clears the setInterval on destroy
    this.carrierId.unsubscribe();
  }

  getMVTowardsPlant(filtersMVDatas: any = {}){
    this.showLoader = true;
    this.http.post("v1/stats/cr/mv_towards_plant", filtersMVDatas, 2).subscribe((response: any) => {
      if (response.statusCode === 200) {
        this.showLoader = false;
        const data = response.data;
        const mvTowardsPlantData = data && data.map((item: any) => {
           let available = item.current_distance && item.current_distance < 250 ? 'Available for tomorrow' : 'Available for the day after tomorrow';
           return {
             _id: item._id,
             vehicleNo: item.vehicle_no ? item.vehicle_no : 'NA',
             state: item.state && item.state.length > 0 ? item.state.join(', ') : 'NA',
             available: available,
             expectedDate: item.availability_date ? this.timeService.toShortDate(item.availability_date, 'yyyy-MM-dd') : 'NA',
             remarks: item.remarks && item.remarks.length > 0 ? item.remarks[0].remark : 'NA',
             remarksDate: item.remarks && item.remarks.length > 0 ? this.timeService.toShortDateTime(item.remarks[0].date, 'dd-MMM-yyyy, hh:mm a') : '',
           }
       })
        
       this.mvTowardsPlantData = mvTowardsPlantData;
       this.dataSource = new MatTableDataSource(mvTowardsPlantData);
       this.dataSource.sort = this.sort;
       this.sortMVTowardsPlant({active:'expectedDate',direction:"desc"})
      }
    }, (error)=> {
      this.showLoader = false;
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a === 'NA' && b === 'NA') {
      return 0;
    }
    if (a === 'NA') {
      return 1;
    }
    if (b === 'NA') {
      return -1;
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortMVTowardsPlant(sort: Sort) {
    const data = this.mvTowardsPlantData.slice();
    if (!sort.active || sort.direction === "") {
      this.dataSource = new MatTableDataSource(data);
      return;
    }

    this.dataSource = new MatTableDataSource(data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "vehicleNo": return this.compare(a.vehicleNo, b.vehicleNo, isAsc);
        case "state": return this.compare(a.state, b.state, isAsc);
        case "available": return this.compare(a.available, b.available, isAsc);
        case "expectedDate": return this.compare(a.expectedDate, b.expectedDate, isAsc);
        case "remarks": return this.compare(a.remarks, b.remarks, isAsc);
        default: return 0;
      }
    }));

    this.dataSource.sort = this.sort;
    return;
  }
      

  filterOptions() {
    this.filteredOptions = this.states.filter(state =>
      state.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  filterVehicleNo(){
    let filtersMVDatas;
    if(this.searchVehicle !== '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray,
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle !== '' && this.selectedStatesArray.length === 0){
      filtersMVDatas = {
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle === '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray
      }
    } else {
      filtersMVDatas = {};
    }
    this.getMVTowardsPlant(filtersMVDatas);
  }

  updateStateName() {
    this.selectedStatesArray = this.filteredOptions
      .filter(option => option.checked)
      .map(option => option.name);

    this.selectedStateNamesString = this.filteredOptions
      .filter(option => option.checked)
      .map(option => option.name)
      .join(', ');
    
    let checkedCount = this.filteredOptions.filter(option => option.checked).length;

    if(checkedCount > 0) {
      this.isStatesSelected = true;
    } else if(checkedCount === 0) {
      this.isStatesSelected = false;
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  toggleOption(option: { value: string, label: string, checked: boolean }) {
    option.checked = !option.checked;
  }

  applySelection() {
    // Handle the apply action
    let filtersMVDatas;
    if(this.searchVehicle !== '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray,
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle !== '' && this.selectedStatesArray.length === 0){
      filtersMVDatas = {
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle === '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray
      }
    } else {
      filtersMVDatas = {};
    }
    this.getMVTowardsPlant(filtersMVDatas);
    this.dropdownOpen = false;
  }

  clearSelection() {
    this.states.forEach(option => option.checked = false);
    this.selectedStateNamesString = '';
    this.selectedStatesArray = [];
    this.isStatesSelected = false;
  }

  handleSelectRemark(element, remark: string) {
    const row = this.dataSource.data.find(row => row._id === element._id);

    row.remarks = remark;
    this.isRemarkSelected = true;
  }

  refreshMVTowardsPlant(){
    this.getMVTowardsPlant({});
    this.selectedStateNamesString = '';
    this.selectedStatesArray = [];
    this.isStatesSelected = false;
    this.searchTerm = '';
    this.dropdownOpen = false;
    this.searchVehicle = '';
    this.selectedRemark = '';
    this.isRemarkSelected = false;
    this.snackbar.openSnackBar('Data refreshed successfully', '');
  }

  saveChangesData(element:any){
    let payload = {
      _id: element._id,
      availability_date: element.expectedDate ? this.timeService.toShortDate(new Date(element.expectedDate).toISOString(), 'yyyy-MM-dd') : 'Invalid date',
      remarks: element.remarks
    }
    this.showLoader = true;
    this.http.post("v1/driver/mv", payload).subscribe((response: any) => {
      if (response.statusCode === 200) {
        this.showLoader = false;
        this.snackbar.openSnackBar('Data saved successfully', '');
      }
    }, (error) => {
      this.showLoader = false;
    });
    let filtersMVDatas;
    if(this.searchVehicle !== '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray,
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle !== '' && this.selectedStatesArray.length === 0){
      filtersMVDatas = {
        vehicle_no: this.searchVehicle
      }
    } else if (this.searchVehicle === '' && this.selectedStatesArray.length > 0){
      filtersMVDatas = {
        states: this.selectedStatesArray
      }
    } else {
      filtersMVDatas = {};
    }
    setTimeout(() => {
      this.getMVTowardsPlant(filtersMVDatas);
    }, 300);
  }

  // get dashboard data
  getDashboardData() {
    this.getStatsSettings(); // get all the stats settings
    this.views.forEach((view) => {
      if (view.id == "liveStatus" && view.show) {
        this.getDeadlineStatus(); // get deadline status data
      } else if (view.id == "overview" && view.show) {
        this.getPreShipmentStatus(); // get pre shipment status data
      } else if (view.id == "acceptance" && view.show) {
        this.getAcceptanceStatus(); // get acceptance data
      } else if (view.id == "statusCharts" && view.show) {
        this.drawInTransitGraphs(); // draw graphs related to in transit shipments
      } else if (view.id == "variationGraphs" && view.show) {
        this.drawPostShipmentGraphs(); // draw graphs related to post shipment
      } else if (view.id == "opsStatus" && view.show) {
        this.getOverallMetrics(); // get overall metrics
      } else if (view.id == "pendingShipments" && view.show) {
        this.getPostTransitShipmentCount(); // get pending shipments
      }
    });
  }

  // get all the stats settings
  getStatsSettings() {
    this.http.get("constants").subscribe((response: any) => {
      if (response.statusCode === 200) {
        const stat = response.data.stats_settings;
        this.stats_settings.deadline_expiry = {
          count: stat.deadline_expiry.count,
          type: Interval[stat.deadline_expiry.type],
        };
        this.stats_settings.shipment_acceptance = {
          count: stat.shipment_acceptance.count,
          type: Interval[stat.shipment_acceptance.type],
        };
        this.stats_settings.shipment_pending = {
          count: stat.shipment_pending.count,
          type: Interval[stat.shipment_pending.type],
        };
        this.stats_settings.shipment_fulfilled = {
          count: stat.shipment_fulfilled.count,
          type: Interval[stat.shipment_fulfilled.type],
        };
        this.stats_settings.ongoing_shipment = {
          count: stat.ongoing_shipment.count,
          type: Interval[stat.ongoing_shipment.type],
        };
        this.stats_settings.outstanding_epods = {
          count: stat.outstanding_epods.count,
          type: Interval[stat.outstanding_epods.type],
        };
        this.stats_settings.operations_status = {
          count: stat.operations_status.count,
          type: Interval[stat.operations_status.type],
        };
        this.stats_settings.top_shippers = {
          count: stat.top_shippers.count,
          type: Interval[stat.top_shippers.type],
        };
        this.stats_settings.average_loading_topX = stat.avg_loading_topX;
      }
    });
  }

  getDeadlineStatus() {
    this.getDeadlineStatusAcceptance(); // get orders nearing acceptance deadline
    this.getDeadlineStatusAssignment(); // get orders nearing assignment deadline
  }

  getPreShipmentStatus() {
    this.getPreShipmentAcceptance(); // get shipements pending acceptance
    this.getPreShipmentAssignment(); // get shipements pending assignment
  }

  getAcceptanceStatus() {
    this.drawSimTrackingConsentGraph(); // get sim tracking consent data and draw pie chart
    this.drawDriverAcceptanceStatusGraph(); // get driver acceptance data and draw pie chart
  }
  // get data and draw graphs related to in transit shipments
  drawInTransitGraphs() {
    this.resetInTransitGraphs();
    this.drawTrackingStatus(); // get tracking status and draw pie chart
    this.drawLiveLateShipmentsGraph(); // get live late shipment data and draw a donought chart
    this.drawOngoingShipmentsGraph(); // get ongoing shipments data and draw a line graph
  }

  drawPostShipmentGraphs() {
    this.resetPostShipmentGraphs();
    this.getPendingEpodsData(); // get pending epods data
    this.drawRequestedVsDispatchedGraph();
    this.drawDeliveryPointsGraph();
  }

  getOverallMetrics() {
    this.resetOverallMetrics();
    this.getFleetUtilizationData(); // get fleet utilization data
    this.drawOperationStatusGraph(); // get operations status data
    this.getTopShippers();
    this.getAverageLoadingUnloadingTime(); // get average loading time
  }

  // get orders nearing acceptance deadline
  getDeadlineStatusAcceptance() {
    this.deadline_status.acceptance.loader = true;
    this.http.get("carrier_stats/acceptance_expiring_in_X", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.deadline_status.acceptance.loader = false;
          this.deadline_status.acceptance.value = response.data.no_of_vehicles;
        }
      },
      (err) => {
        this.deadline_status.acceptance.loader = false;
        this.deadline_status.acceptance.value = "--";
        console.log("Error>>", err.error.message);
      }
    );
  }

  // get orders nearing assignment deadline
  getDeadlineStatusAssignment() {
    this.deadline_status.assignment.loader = true;
    this.http.get("carrier_stats/assignment_expiring_in_X", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.deadline_status.assignment.loader = false;
          this.deadline_status.assignment.value = response.data.no_of_vehicles;
        }
      },
      (err) => {
        this.deadline_status.assignment.loader = false;
        this.deadline_status.assignment.value = "--";
        console.log("Error>>", err.error.message);
      }
    );
  }

  // get shipements pending assignment
  getPreShipmentAssignment() {
    this.preShipment_pending_data.assignment.loader = true;
    this.http.get("carrier_stats/pending_assignment", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.preShipment_pending_data.assignment.loader = false;
          this.preShipment_pending_data.assignment.value =
            response.data.no_of_vehicles;
        }
      },
      (err) => {
        this.preShipment_pending_data.assignment.loader = false;
        this.preShipment_pending_data.assignment.value = "--";
        console.log("Error>>", err.error.message);
      }
    );
  }

  // get shipements pending acceptance
  getPreShipmentAcceptance() {
    this.preShipment_pending_data.acceptance.loader = true;
    this.http.get("carrier_stats/pending_acceptance", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.preShipment_pending_data.acceptance.loader = false;
          this.preShipment_pending_data.acceptance.value =
            response.data.no_of_vehicles;
        }
      },
      (err) => {
        this.preShipment_pending_data.acceptance.loader = false;
        this.preShipment_pending_data.acceptance.value = "--";
        console.log("Error>>", err.error.message);
      }
    );
  }

  drawSimTrackingConsentGraph() {
    this.sim_tracking_consent_data.loader = true;
    this.http.get("carrier_stats/consent_status", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.sim_tracking_consent_data.loader = false;
          this.sim_tracking_consent_data.error_message = "";
          this.sim_tracking_consent_data.consent_available =
            response.data.yes_consent || "-";
          this.sim_tracking_consent_data.consent_unavailable =
            response.data.no_consent || "-";
          this.sim_tracking_consent_available = response.data.yes_consent;
          this.sim_tracking_consent_unavailable = response.data.no_consent;
          this.sim_tracking_consent_data.total_sum = response.data.total_sum;
          this.calculateSimTrackingConsentProgressBarValues();
          this.simTrackingConsentStatus = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.sim_tracking_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            tooltip: {
              trigger: "item",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              formatter: "{a} <br/>{b} : {c} Vehicles",
              backgroundColor: "#e7eff7",
            },
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.consent_details"
                ),
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: this.sim_tracking_consent_data.consent_available,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.consent_available"
                    ),
                    itemStyle: { color: "#229954" },
                    id: "consent_available",
                  },
                  {
                    value: this.sim_tracking_consent_data.consent_unavailable,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.consent_unavailable"
                    ),
                    itemStyle: { color: "#C0392B" },
                    id: "consent_unavailable",
                  },
                ],
                label: {
                  position: "inner",
                  alignTo: "none",
                  bleedMargin: 5,
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "14",
                      fontWeight: "bold",
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.sim_tracking_consent_data.loader = false;
        this.sim_tracking_consent_data.error_message = err.error.message;
      }
    );
  }

  // calculate the value for progress bar
  calculateSimTrackingConsentProgressBarValues() {
    const total = Number(this.sim_tracking_consent_data.total_sum);
    if (total !== 0) {
      this.sim_tracking_progress_bar.consent_available =
        (Number(this.sim_tracking_consent_available) / total) * 100;
      this.sim_tracking_progress_bar.consent_unavailable =
        (Number(this.sim_tracking_consent_unavailable) / total) * 100;
    }
  }

  drawDriverAcceptanceStatusGraph() {
    this.driver_acceptance_status_data.loader = true;
    this.http.get("carrier_stats/driver_acceptance_status", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.driver_acceptance_status_data.loader = false;
          this.driver_acceptance_status_data.error_message = "";
          this.driver_acceptance_status_data.driver_accepted =
            response.data.accepted || "-";
          this.driver_acceptance_status_data.driver_yet_to_accept =
            response.data.not_accepted || "-";
          this.driver_acceptance_status_data.total =
            response.data.accepted + response.data.not_accepted;
          this.driver_acceptance_status_accepted = response.data.accepted;
          this.driver_acceptance_status_yet_to_accept =
            response.data.not_accepted;
          this.calculateDriverAcceptanceProgressBarValues();
          this.driverAcceptanceStatus = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.driver_acceptance_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} Vehicles",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.acceptance_details"
                ),
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: this.driver_acceptance_status_data.driver_accepted,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.driver_accepted"
                    ),
                    itemStyle: { color: "#229954" },
                    id: "driver_accepted",
                  },
                  {
                    value:
                      this.driver_acceptance_status_data.driver_yet_to_accept,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.driver_yet_to_accept"
                    ),
                    itemStyle: { color: "#C0392B" },
                    id: "driver_not_accepted",
                  },
                ],
                label: {
                  position: "inner",
                  alignTo: "none",
                  bleedMargin: 5,
                  emphasis: {
                    textStyle: {
                      fontSize: "14",
                      fontWeight: "bold",
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.driver_acceptance_status_data.loader = false;
        this.driver_acceptance_status_data.error_message = err.error.message;
      }
    );
  }

  calculateDriverAcceptanceProgressBarValues() {
    const total = Number(this.driver_acceptance_status_data.total);
    if (total !== 0) {
      this.driver_acceptance_progress_bar.driver_accepted =
        (Number(this.driver_acceptance_status_accepted) / total) * 100;
      this.driver_acceptance_progress_bar.driver_yet_to_accept =
        (Number(this.driver_acceptance_status_yet_to_accept) / total) * 100;
    }
  }

  drawTrackingStatus() {
    this.tracking_status_data.loader = true;
    this.http.get("carrier_stats/tracking_status", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.tracking_status_data.loader = false;
          this.tracking_status_data.non_trackable =
            response.data.non_trackable || "-";
          this.tracking_status_data.trackable = response.data.trackable || "-";
          this.tracking_status_data.trackable_app = response.data.trackable_app;
          this.tracking_status_data.trackable_gps = response.data.trackable_gps;
          this.tracking_status_data.trackable_sim = response.data.trackable_sim;
          this.non_trackable_no = response.data.non_trackable;
          this.trackable_no = response.data.trackable;
          this.calculateProgressBarValues(); // calculate the value for progress bar
          this.tracking_status_data.error_message = "";
          const context = this;
          this.trackingStatusOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.tracking_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} Vehicles",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.tracking_status"
                ),
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: this.tracking_status_data.trackable,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.trackable"
                    ),
                  },
                  {
                    value: this.tracking_status_data.non_trackable,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.non_trackable"
                    ),
                  },
                ],
                label: {
                  position: "inner",
                  alignTo: "none",
                  bleedMargin: 5,
                  emphasis: {
                    show: true,
                    textStyle: {
                      // fontSize: '14',
                      // fontWeight: 'bold',
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.tracking_status_data.loader = false;
        this.tracking_status_data.error_message = err.error.message;
      }
    );
  }

  // calculate the value for progress bar
  calculateProgressBarValues() {
    const total = Number(this.trackable_no);
    if (total !== 0) {
      this.progress_bar.app =
        (Number(this.tracking_status_data.trackable_app) / total) * 100;
      this.progress_bar.sim =
        (Number(this.tracking_status_data.trackable_sim) / total) * 100;
      this.progress_bar.gps =
        (Number(this.tracking_status_data.trackable_gps) / total) * 100;
    }
  }

  drawLiveLateShipmentsGraph() {
    this.live_late_shipments_data.loader = true;
    this.http.get("carrier_stats/delay_status", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.live_late_shipments_data.loader = false;
          this.live_late_shipments_data._id = response.data._id;
          this.live_late_shipments_data.delayed_shipments =
            response.data.delayed_shipments;
          this.live_late_shipments_data.ontime_shipments =
            response.data.ontime_shipments;
          this.live_late_shipments_data.error_message = "";
          const delayed = this.translation.instant(
            "OVERVIEW_DASHBOARD.delayed_shipments"
          );
          const ontime = this.translation.instant(
            "OVERVIEW_DASHBOARD.on_time_shipments"
          );
          const context = this;
          this.liveLateShipmentsOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.live_late_shipments"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b}: {c} Shipments",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            legend: {
              top: 0,
              right: 50,
              bottom: 20,
              textStyle: {
                fontFamily: "Muli",
              },
            },
            graphic: [
              {
                type: "image",
                id: "logo",
                right: 10,
                top: 0,
                z: -10,
                bounding: "raw",
                origin: [70, 70],
                style: {
                  image: "assets/redirect-icon.png",
                  width: 16,
                  height: 16,
                  opacity: 0.8,
                },
                onclick(event) {
                  context.openShipmentDashboard(event, "live_delayed");
                },
              },
              {
                type: "group",
                left: "53%",
                right: "10%",
                top: "40%",
                children: [
                  {
                    type: "circle",
                    style: {
                      fill: "#c23531",
                    },
                    shape: {
                      cx: -120,
                      cy: -25,
                      r: 8,
                    },
                  },
                  {
                    type: "circle",
                    style: {
                      fill: "#2f4654",
                    },
                    shape: {
                      cx: -120,
                      cy: 23,
                      r: 8,
                    },
                  },
                  {
                    type: "text",
                    z: 100,
                    position: [-100, -31],
                    style: {
                      fill: "#100",
                      text: [
                        `${delayed} : ${this.live_late_shipments_data.delayed_shipments}`,
                        // `${ontime}  : ${this.live_late_shipments_data.ontime_shipments}`,
                      ].join("\n\n\n"),
                      font: "bold 14px  Muli",
                    },
                  },
                  {
                    type: "text",
                    z: 100,
                    position: [-100, 17],
                    style: {
                      fill: "#100",
                      text: [
                        // `${delayed} : ${this.live_late_shipments_data.delayed_shipments}`,
                        `${ontime}  : ${this.live_late_shipments_data.ontime_shipments}`,
                      ].join("\n\n\n"),
                      font: "bold 14px  Muli",
                    },
                  },
                ],
              },
            ],
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.shipments_status"
                ),
                type: "pie",
                radius: ["45%", "55%"],
                center: ["30%", "50%"],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: false,
                    position: "center",
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "20",
                      fontWeight: "bold",
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
                labelLine: {
                  normal: {
                    show: false,
                  },
                },
                data: [
                  {
                    value: this.live_late_shipments_data.delayed_shipments,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.delayed"
                    ),
                  },
                  {
                    value: this.live_late_shipments_data.ontime_shipments,
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.no_delay"
                    ),
                  },
                ],
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.live_late_shipments_data.loader = false;
        this.live_late_shipments_data.error_message = err.error.message;
      }
    );
  }

  // draw graphs related to operation status
  drawOperationStatusGraph() {
    this.operation_status_data.loader = true;
    this.http.get("carrier_stats/operations_status", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.operation_status_data.loader = false;
          this.operation_status_data.error_message = "";
          response.data.forEach((item) => {
            if (item._id == "ITNS") {
              this.operation_status_data.in_transit = item.no_of_shipments;
            } else if (item._id == "CPTD") {
              this.operation_status_data.delivered = item.no_of_shipments;
            } else if (item._id == "SP") {
              this.operation_status_data.towards_pickup = item.no_of_shipments;
            } else if (item._id == "AP") {
              this.operation_status_data.at_pickup = item.no_of_shipments;
            } else if (item._id == "ALD") {
              this.operation_status_data.at_delivery = item.no_of_shipments;
            } else if (item._id == "ABTR") {
              this.operation_status_data.about_to_reach = item.no_of_shipments;
            }
          });
          const last =
            this.translation.instant("OVERVIEW_DASHBOARD.last") +
            " " +
            this.stats_settings.operations_status.count +
            " " +
            this.stats_settings.operations_status.type;
          const context = this;
          this.operationStatusOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.operation_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
              subtext: `${last}`,
              subtextStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                color: "#555",
                verticalAlign: "bottom",
                lineHeight: 5,
              },
            },
            legend: {
              show: true,
              textStyle: {
                fontFamily: "Muli",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c} Vehicles",
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            xAxis: {
              type: "category",
              data: [
                this.translation.instant("OVERVIEW_DASHBOARD.towards_pickup"),
                this.translation.instant("OVERVIEW_DASHBOARD.at_pickup"),
                this.translation.instant("OVERVIEW_DASHBOARD.in_transit"),
                this.translation.instant("OVERVIEW_DASHBOARD.at_delivery"),
                this.translation.instant("OVERVIEW_DASHBOARD.delivered"),
                this.translation.instant("OVERVIEW_DASHBOARD.about_to_reach"),
              ],
            },
            yAxis: {
              type: "value",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.no_of_vehicles"
              ),
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                lineHeight: 100,
                color: "#e2dcdf3",
              },
              axisLabel: {
                formatter: "{value}",
              },
              nameLocation: "center",
              minInterval: 1,
            },
            graphic: [
              {
                type: "image",
                id: "logo",
                right: 10,
                top: 0,
                z: -10,
                bounding: "raw",
                origin: [70, 70],
                style: {
                  image: "assets/redirect-icon.png",
                  width: 16,
                  height: 16,
                  opacity: 0.8,
                },
                onclick(event) {
                  context.openShipmentDashboard(event, "operations");
                },
              },
            ],
            series: [
              {
                type: "bar",
                barMaxWidth: "50%",
                data: [
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.towards_pickup"
                    ),
                    value: context.operation_status_data.towards_pickup,
                    // itemStyle: {  color: '#f7464a' },
                  },
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.at_pickup"
                    ),
                    value: context.operation_status_data.at_pickup,
                    // itemStyle: { color: '#e2dcdf3' },
                  },
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.in_transit"
                    ),
                    value: context.operation_status_data.in_transit,
                    // itemStyle: { color: '#c54e07' },
                  },
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.at_delivery"
                    ),
                    value: context.operation_status_data.at_delivery,
                    // itemStyle: { color: '#ffd15c' },
                  },
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.delivered"
                    ),
                    value: context.operation_status_data.delivered,
                    // itemStyle: { color: '#46bfbd' },
                  },
                  {
                    name: this.translation.instant(
                      "OVERVIEW_DASHBOARD.about_to_reach"
                    ),
                    value: context.operation_status_data.about_to_reach,
                    // itemStyle: { color: '#46bfbd' },
                  },
                ],
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.operation_status_data.loader = false;
        this.operation_status_data.error_message = err.error.message;
      }
    );
  }

  // get dispatched shipments data and draw a line graph
  drawOngoingShipmentsGraph() {
    this.dispatched_shipments_graph.loader = true;
    this.http.get("carrier_stats/ongoing_variation", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.dispatched_shipments_graph.loader = false;
          this.dispatched_shipments_graph.error_message = "";
          response.data.forEach((item) => {
            const date = this.timeService.toShortDateMonth(item._id);
            this.dispatched_shipments_graph.date.push(date);
            this.dispatched_shipments_graph.allocated.push(item.allocated);
            this.dispatched_shipments_graph.assigned.push(item.assigned);
          });

          this.dispatchedShipmentsOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.ongoing_variation_graph"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            tooltip: {
              trigger: "axis",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            legend: {
              show: true,
              data: [
                this.translation.instant(
                  "OVERVIEW_DASHBOARD.allocated_vehicles"
                ),
                this.translation.instant(
                  "OVERVIEW_DASHBOARD.assigned_vehicles"
                ),
              ],
              top: "30",
              textStyle: {
                fontFamily: "Muli",
              },
            },
            xAxis: {
              type: "category",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.scheduled_pickup_date"
              ),
              nameLocation: "center",
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                verticalAlign: "top",
                lineHeight: 48,
                color: "#e2dcdf3",
              },
              boundaryGap: false,
              data: this.dispatched_shipments_graph.date,
            },
            yAxis: {
              type: "value",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.no_of_vehicles"
              ),
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                lineHeight: 120,
                color: "#e2dcdf3",
              },
              axisLabel: {
                formatter: "{value}",
              },
              nameLocation: "center",
              minInterval: 1,
            },
            dataZoom: [
              {
                type: "slider",
                minValueSpan: 1,
              },
              {
                start: 0,
                end: 10,
                handleIcon:
                  "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                handleStyle: {
                  color: "#fff",
                  shadowBlur: 3,
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2,
                },
                textStyle: {
                  fontSize: 10,
                  fontWeight: "bold",
                },
              },
            ],
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.allocated_vehicles"
                ),
                data: this.dispatched_shipments_graph.allocated,
                type: "line",
                showSymbol: false,
              },
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.assigned_vehicles"
                ),
                data: this.dispatched_shipments_graph.assigned,
                type: "line",
                showSymbol: false,
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.dispatched_shipments_graph.loader = false;
        this.dispatched_shipments_graph.error_message = err.error.message;
      }
    );
  }

  // get the fullfilled shipments data and draw line graph
  drawRequestedVsDispatchedGraph() {
    this.fulfilled_shipments_graph.loader = true;
    this.http.get("carrier_stats/fulfilled_variation", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.fulfilled_shipments_graph.loader = false;
          this.fulfilled_shipments_graph.error_message = "";
          response.data.forEach((item) => {
            const date = this.timeService.toShortDateMonth(item._id);
            this.fulfilled_shipments_graph.date.push(date);
            this.fulfilled_shipments_graph.requested.push(item.allocated);
            this.fulfilled_shipments_graph.fulfilled.push(item.finished);
          });
          const context = this;

          this.requestedVsDispatchedOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.fulfilled_shipment_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
              subtext:
                this.translation.instant("OVERVIEW_DASHBOARD.last") +
                " " +
                context.stats_settings.shipment_fulfilled.count +
                " " +
                context.stats_settings.shipment_fulfilled.type,
              subtextStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                color: "#555",
                verticalAlign: "bottom",
                lineHeight: 5,
              },
            },
            tooltip: {
              trigger: "axis",
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            legend: {
              data: [
                this.translation.instant(
                  "OVERVIEW_DASHBOARD.requested_vehicles"
                ),
                this.translation.instant(
                  "OVERVIEW_DASHBOARD.fulfilled_shipments"
                ),
              ],
              top: "30",
              textStyle: {
                fontFamily: "Muli",
              },
            },
            xAxis: {
              boundaryGap: false,
              type: "category",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.scheduled_delivery_date"
              ),
              nameLocation: "center",
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                verticalAlign: "top",
                lineHeight: 48,
                color: "#e2dcdf3",
              },
              data: this.fulfilled_shipments_graph.date,
            },
            yAxis: {
              type: "value",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.no_of_vehicles"
              ),
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                lineHeight: 110,
                color: "#e2dcdf3",
              },
              axisLabel: {
                formatter: "{value}",
              },
              nameLocation: "center",
              minInterval: 1,
            },
            dataZoom: [
              {
                type: "slider",
                minValueSpan: 1,
              },
              {
                start: 0,
                end: 10,
                handleIcon:
                  "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                handleStyle: {
                  color: "#fff",
                  shadowBlur: 3,
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2,
                },
                textStyle: {
                  fontSize: 10,
                  fontWeight: "bold",
                },
              },
            ],
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.requested_vehicles"
                ),
                type: "line",
                data: context.fulfilled_shipments_graph.requested,
                showSymbol: false,
              },
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.fulfilled_shipments"
                ),
                type: "line",
                data: context.fulfilled_shipments_graph.fulfilled,
                showSymbol: false,
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.fulfilled_shipments_graph.loader = false;
        this.fulfilled_shipments_graph.error_message = err.error.message;
      }
    );
  }

  // get fleet utilization data
  getFleetUtilizationData() {
    this.fleet_utilization_data.loader = true;
    this.http.get("carrier_stats/fleet_utilization", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.fleet_utilization_data.loader = false;
          this.fleet_utilization_data.error_message = "";
          this.fleet_utilization_data.total_vehicles =
            response.data.no_of_vehicles;
          this.fleet_utilization_data.free_vehicles =
            response.data.free_vehicles;
          this.fleet_utilization_data.on_shipment = response.data.busy_vehicles;
        }
      },
      (err) => {
        this.fleet_utilization_data.loader = false;
        this.fleet_utilization_data.error_message = err.error.message;
      }
    );
  }

  // get delivery points data
  drawDeliveryPointsGraph() {
    this.delivery_point_data.loader = true;
    this.http.get("carrier_stats/deliveries_variation", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.delivery_point_data.loader = false;
          this.delivery_point_data.error_message = "";
          response.data.forEach((element) => {
            this.delivery_point_data.data.sin.push(element.SIN);
            this.delivery_point_data.data.total_deliveries.push(
              element.total_deliveries
            );
            this.delivery_point_data.data.finished_deliveries.push(
              element.finished_deliveries
            );
          });

          this.deliveryPointsOption = {
            title: {
              text: this.translation.instant(
                "OVERVIEW_DASHBOARD.delivery_points_status"
              ),
              textStyle: {
                fontFamily: "Muli",
                fontWeight: "bold",
                fontSize: 16,
              },
            },
            legend: {
              data: [
                this.translation.instant("OVERVIEW_DASHBOARD.total_deliveries"),
                this.translation.instant(
                  "OVERVIEW_DASHBOARD.completed_deliveries"
                ),
              ],
              textStyle: {
                fontFamily: "Muli",
              },
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
              textStyle: {
                fontFamily: "Muli",
                color: "#04525e",
              },
              backgroundColor: "#e7eff7",
            },
            xAxis: [
              {
                boundaryGap: true,
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.shipment_id"
                ),
                nameLocation: "center",
                nameTextStyle: {
                  fontWeight: "bold",
                  fontFamily: "Muli",
                  fontSize: 14,
                  verticalAlign: "top",
                  lineHeight: 48,
                  color: "#e2dcdf3",
                },
                type: "category",
                data: this.delivery_point_data.data.sin,
                scale: true,
              },
            ],
            yAxis: {
              type: "value",
              name: this.translation.instant(
                "OVERVIEW_DASHBOARD.no_of_deliveries"
              ),
              nameTextStyle: {
                fontWeight: "bold",
                fontFamily: "Muli",
                fontSize: 14,
                lineHeight: 110,
                color: "#e2dcdf3",
              },
              nameLocation: "center",
              minInterval: 1,
            },
            dataZoom: [
              {
                type: "slider",
                minValueSpan: 10,
                maxValueSpan: 10,
                start: 90,
                end: 100,
              },
              {
                start: 0,
                end: 10,
                handleIcon:
                  "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
                handleStyle: {
                  color: "#fff",
                  shadowBlur: 3,
                  shadowColor: "rgba(0, 0, 0, 0.6)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2,
                },
                textStyle: {
                  fontSize: 10,
                  fontWeight: "bold",
                },
              },
            ],
            series: [
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.total_deliveries"
                ),
                type: "bar",
                barGap: "0.1",
                data: this.delivery_point_data.data.total_deliveries,
              },
              {
                name: this.translation.instant(
                  "OVERVIEW_DASHBOARD.completed_deliveries"
                ),
                type: "bar",
                data: this.delivery_point_data.data.finished_deliveries,
              },
            ],
            color: this.colorPalette,
          };
        }
      },
      (err) => {
        this.delivery_point_data.loader = false;
        this.delivery_point_data.error_message = err.error.message;
      }
    );
  }

  getPendingEpodsData() {
    this.outstanding_epods_data.loader = true;
    this.http.get("carrier_stats/pending_epods", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.outstanding_epods_data.loader = false;
          this.outstanding_epods_data.error_message = "";
          this.outstanding_epods_data.value = response.data.no_of_deliveries;
        }
      },
      (err) => {
        this.outstanding_epods_data.loader = false;
        this.outstanding_epods_data.error_message = err.error.message;
      }
    );
  }

  getTopShippers() {
    this.top_shippers.loader = true;
    this.http.get("carrier_stats/top_shippers", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.top_shippers.loader = false;
          this.top_shippers.error_message = "";

          response.data.forEach((item) => {
            this.top_shippers.total_vehicles += item.no_of_shipments;
            this.top_shippers.shippers.push({
              name: item._id,
              no_of_shipments: item.no_of_shipments,
            });
          });
        }
      },
      (err) => {
        this.top_shippers.loader = false;
        this.top_shippers.error_message = err.error.message;
      }
    );
  }

  // get average laoding time
  getAverageLoadingUnloadingTime() {
    this.loading_off_loading_time_data.loader = true;
    this.http.get("carrier_stats/avg_loading_time", {}, 2).subscribe(
      (response: any) => {
        this.loading_off_loading_time_data.loader = false;
        this.loading_off_loading_time_data.error_message = "";
        response.data.forEach((item) => {
          this.loading_off_loading_time_data.data.push({
            average_loading_time: item.avg_loading_wait_time
              ? this.timeService.minutesToDaysHours(
                  parseInt(item.avg_loading_wait_time.avg)
                )
              : "N/A",
            average_unloading_time: item.avg_unloading_wait_time
              ? this.timeService.minutesToDaysHours(
                  parseInt(item.avg_unloading_wait_time.avg)
                )
              : "N/A",
            area: item.area,
            name: item.name,
          });
        });
      },
      (err) => {
        this.loading_off_loading_time_data.loader = false;
        this.loading_off_loading_time_data.error_message = err.error.message;
      }
    );
  }

  refresh() {
    this.resetDashboardData();
    this.getDashboardData();
  }

  resetDashboardData() {
    this.resetInTransitGraphs();
    this.resetPostShipmentGraphs();
    this.resetOverallMetrics();
  }

  resetInTransitGraphs() {
    this.dispatched_shipments_graph = {
      date: [],
      allocated: [],
      assigned: [],
      error_message: "",
      loader: false,
    };
  }

  resetPostShipmentGraphs() {
    this.fulfilled_shipments_graph = {
      date: [],
      requested: [],
      fulfilled: [],
      error_message: "",
      loader: false,
    };
    this.delivery_point_data = {
      data: {
        sin: [],
        total_deliveries: [],
        finished_deliveries: [],
      },
      error_message: "",
      loader: false,
    };
  }

  resetOverallMetrics() {
    this.operation_status_data = {
      at_pickup: 0,
      towards_pickup: 0,
      in_transit: 0,
      at_delivery: 0,
      delivered: 0,
      about_to_reach: 0,
      error_message: "",
      loader: false,
    };
    this.top_shippers = {
      shippers: [],
      total_vehicles: 0,
      loader: false,
      error_message: "",
    };
    this.loading_off_loading_time_data = {
      loader: false,
      error_message: "",
      data: [],
    };
  }

  openDashboard(ev: Event, mode, type) {
    this.router.navigateByUrl(`dashboard/${mode}/${type}`);
    ev.stopPropagation();
  }
  openShipmentDashboard(ev: Event, type, dueIn: any = {}) {
    let data = type;
    if (dueIn && dueIn.name) data = `${type}-${dueIn.name}`;
    this.router.navigateByUrl(`shipmentsDashboard/${data}`);
    if (ev) ev.stopPropagation();
  }

  updateView(event, index) {
    if (event.isUserInput) {
      this.views[index].show = event.source._selected;
      if (event.source._selected) {
        if (this.views[index].id == "liveStatus") {
          this.getDeadlineStatus();
        } else if (this.views[index].id == "overview") {
          this.getPreShipmentStatus();
        } else if (this.views[index].id == "acceptance") {
          this.getAcceptanceStatus();
        } else if (this.views[index].id == "statusCharts") {
          this.drawInTransitGraphs();
        } else if (this.views[index].id == "variationGraphs") {
          this.drawPostShipmentGraphs();
        } else if (this.views[index].id == "opsStatus") {
          this.getOverallMetrics();
        }
      }
      this.checkView();
      this.checkValues = this.views.map((e) => (e.show ? e.id : undefined));
      this.saveDashboardLayout();
    }
  }

  checkView() {
    for (let i = 0; i < this.views.length; i++) {
      if (this.views[i].show) {
        this.show_warning = false;
        break;
      } else {
        this.show_warning = true;
        continue;
      }
    }
  }
  saveDashboardLayout(showFeedback = false) {
    this.storage.setToLocalStorage(DashboardLayout, JSON.stringify(this.views));
    if (showFeedback) {
      this.snackbar.openSnackBar(
        this.translation.instant("MESSAGE.overview.layoutSaved")
      );
      this.showFeedback = false;
    }
  }

  openReorderModal(): void {
    this.dashboardLayoutDialog = this.dialog.open(this.reorderRows, {
      width: "350px",
    });

    this.dashboardLayoutDialog.afterClosed().subscribe(() => {
      this.saveDashboardLayout(this.showFeedback);
    });
  }

  consentPieChartClicked(event) {
    if (event.data.id == "consent_available") {
      this.sim_tracking_consent_data.consent = true;
    } else {
      this.sim_tracking_consent_data.consent = false;
    }
  }

  acceptancePieChartClicked(event) {
    if (event.data.id == "driver_accepted") {
      this.driver_acceptance_status_data.acceptance = true;
    } else {
      this.driver_acceptance_status_data.acceptance = false;
    }
  }

  openModal(index, val: any = "N/A") {
    const dialogData: any = {
      type: index,
      count: val,
      consent: this.sim_tracking_consent_data.consent,
      acceptance: this.driver_acceptance_status_data.acceptance,
    };
    let url = "";
    if (index == 0) {
      dialogData.heading = this.translation.instant("Acceptance Deadline");
      url = "carrier_stats/acceptance_expiring_details";
    } else if (index == 1) {
      dialogData.heading = this.translation.instant("Assignment Deadline");
      url = "carrier_stats/assignment_expiring_details";
    }

    if (url) {
      this.showLoader = true;
      this.http.get(url, {}, 2).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data) {
            if (data.data && data.data.length) {
              dialogData.details = data.data;
              const dialogRef = this.dialog.open(DeadlineModalsComponent, {
                data: dialogData,
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {});
            } else {
              this.snackbar.openSnackBar(
                this.translation.instant("MESSAGE.overview.noData"),
                "",
                "warn"
              );
            }
          }
        },
        (err: any) => {
          this.showLoader = false;
          console.log("Error::", err.error.message);
          this.snackbar.openSnackBar(
            err.error.message ||
              this.translation.instant("MESSAGE.overview.wrong"),
            "",
            "warn"
          );
        }
      );
    }
  }

  openPreShipmentModal(index, val: any = "N/A") {
    const dialogData: any = {
      type: index,
      count: val,
    };
    let url: any = "";
    let options: any = {};
    if (index == 0) {
      dialogData.heading = this.translation.instant(
        "OVERVIEW_DASHBOARD.pending_acceptance"
      );
      url = "carrier_stats/pending_acceptance_details";
    } else if (index == 1) {
      dialogData.heading = this.translation.instant(
        "OVERVIEW_DASHBOARD.pending_assignment"
      );
      url = "carrier_stats/pending_assignment_details";
    } else if (index == 2) {
      dialogData.heading = this.translation.instant("MESSAGE.overview.consent");
      url = "carrier_stats/consent_details";
      options = {
        consent: this.sim_tracking_consent_data.consent,
      };
    } else if (index == 3) {
      dialogData.heading = this.translation.instant(
        "MESSAGE.overview.acceptanceStatus"
      );
      url = "carrier_stats/driver_acceptance_details";
      options = {
        acceptance: this.driver_acceptance_status_data.acceptance,
      };
    }
    if (url) {
      this.showLoader = true;
      this.http.get(url, options, 2).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data) {
            if (data.data && data.data.length) {
              dialogData.details = data.data;
              const dialogRef = this.dialog.open(PreShipmentModalsComponent, {
                data: dialogData,
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {});
            } else {
              this.snackbar.openSnackBar(
                this.translation.instant("MESSAGE.overview.noData"),
                "",
                "warn"
              );
            }
          }
        },
        (err: any) => {
          this.showLoader = false;
          console.log("Error::", err.error.message);
          this.snackbar.openSnackBar(
            err.error.message ||
              this.translation.instant("MESSAGE.overview.wrong"),
            "",
            "warn"
          );
        }
      );
    }
  }

  openPostShipmentModal(index, val: any = "N/A") {
    const dialogData: any = {
      type: index,
      count: val,
    };
    let url: any = "";
    if (index == 0) {
      dialogData.heading = this.translation.instant("Fleet Utilization");
      url = "carrier_stats/fleet_by_shipper";
    } else if (index == 1) {
      dialogData.heading = this.translation.instant("Outstanding E-PODs");
      url = "carrier_stats/pending_epods_details";
    }
    if (url) {
      this.showLoader = true;
      this.http.get(url, {}, 2).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data) {
            if (data.data && data.data.length) {
              dialogData.details = data.data;
              const dialogRef = this.dialog.open(PostShipmentModalsComponent, {
                data: dialogData,
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {});
            } else {
              this.snackbar.openSnackBar(
                this.translation.instant("MESSAGE.overview.noData"),
                "",
                "warn"
              );
            }
          }
        },
        (err: any) => {
          this.showLoader = false;
          console.log("Error::", err.error.message);
          this.snackbar.openSnackBar(
            err.error.message ||
              this.translation.instant("MESSAGE.overview.wrong"),
            "",
            "warn"
          );
        }
      );
    }
  }

  getPostTransitShipmentCount() {
    this.postTransitShipmentCount = [];
    this.http.get("v1/carrier_stats/due_shipments", {}, 2).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          const data = response.data;
          Object.keys(data).forEach((key) => {
            if (key !== "_id") {
              this.postTransitShipmentCount.push({
                name: key,
                value: data[key],
              });
            }
          });
          // this.postTransitShipmentCount = response.data.count;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, "", "err");
      }
    );
  }

  initChart(vehicleNo: string) {
    let filter = {
      vehicle_no: vehicleNo,
    };

    this.showLoader = true;
    this.http.post("v1/stats/cr/mvPercentage", filter, 2).subscribe((response:any) => {
      this.showLoader = false;
      const data = response.data;
      // const carriers = data.carriers ? data.carriers : [];
      const carrierWithDates = data.date ? data.date : [];
      const totalTrips = data.trips ? data.trips : 0;
      this.totalTripChart = totalTrips;
      const availableVehicles = carrierWithDates.filter((carrier: any) => this.carrierID === carrier.carrier);
const nonAvailableVehicles = carrierWithDates.filter((carrier: any) => this.carrierID !== carrier.carrier);
      const availableVehiclesCount = availableVehicles.length;
      const notAvailableVehiclesCount = nonAvailableVehicles.length;
      const availableTripsChart = Number((availableVehiclesCount/ (totalTrips) * 100).toFixed(2));
      this.availableVehiclesTrip = availableTripsChart;
      const nonAvailableTripsChart = Number((notAvailableVehiclesCount/ (totalTrips) * 100).toFixed(2));
      
      this.previousVehiclesChartData = [
        {value:availableTripsChart, name: this.carrierName, itemStyle: { color: '#0ABD80' }},
        {value:nonAvailableTripsChart, name:'Other Transporters', itemStyle: { color: '#F67374' }}
      ];

      const previousTrips = carrierWithDates.map((carrier) => {
        return {
          date: this.timeService.toShortDate(carrier.created_at, 'dd MMM yyyy'),
          available: this.carrierID === carrier.carrier,
        }
      });

      this.previousTripsChart = previousTrips.reverse();
      this.vehicleChartOptions = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '45%'],
            data: this.previousVehiclesChartData
          }
        ]
      };
    }, (error) => {
      console.log("error", error);
      this.showLoader = false;
    })  
    this.showLoader = true;
    this.http.post("v1/stats/cr/driver_owner_broker_details", filter, 2).subscribe((response:any) => {
      this.showLoader = false; 
      const data = response.data
      this.vehicleContactDetails = {
        driver_name: data.name || 'N/A',
        driver_mobile: data.mobile || '--------',
        owner_name: data.owner_name || 'N/A',
        owner_mobile: data.owner_mobile || '--------',
        broker_name: data.others && data.others.broker_name || 'N/A',
        broker_mobile: data.others && data.others.broker_mobile || '--------'
      }
    }, (error) => {
      console.log("error", error);
      this.showLoader = false;
    })  
  }
}
